angular.module('FlexyBeautyApp.services').
factory('SaleItem',["HumanResource","RootStatCategorie","HrRootCategory","NbCustormerCategoryStat","TypeOfCustomerRootCategory","TypeOfCustomer","HrRootOccupationRateCategory","HumanResourceExtra","HumanResourceData",
    function (HumanResource,RootStatCategorie,HrRootCategory,NbCustormerCategoryStat,TypeOfCustomerRootCategory,TypeOfCustomer,HrRootOccupationRateCategory,HumanResourceExtra,HumanResourceData) {
    const SaleItem = function () {};

    SaleItem.prototype.matchSpecificMatchingOfItem = function(){
        return false;
    };

    SaleItem.prototype.matchSaleItemMatching = function(saleObject, firstDayOfPeriod, currentDay){
        let matchCommonMatching = false;
        if (
            (saleObject instanceof HumanResource && this.humanResource === saleObject) ||
            (saleObject === HumanResourceExtra && (this.humanResource === null || (this.humanResource && HumanResourceData.getActiveList().indexOf(this.humanResource) === -1)) ) ||
            (saleObject === TypeOfCustomerRootCategory) ||
            (saleObject === TypeOfCustomer.OLD_CUSTOMER && this.getSale().customer && (this.getSale().customer.hasSaleBefore(firstDayOfPeriod) || this.getSale().customer.hasBookingBefore(firstDayOfPeriod, this.getSale()))) ||
            (saleObject === TypeOfCustomer.NEW_CUSTOMER && (!this.getSale().customer || (!this.getSale().customer.hasSaleBefore(currentDay) && !this.getSale().customer.hasBookingBefore(currentDay, this.getSale()) && (this.getSale().booking && this.getSale().booking.day.id >= firstDayOfPeriod.id || !this.getSale().booking)))) ||
            (saleObject === HrRootOccupationRateCategory)){
            matchCommonMatching = true;
        }
        return matchCommonMatching;
    };

    SaleItem.prototype.getParentItem = function(){
        return null;
    };

    SaleItem.prototype.matchSaleTreeMatching = function(saleObject){
        let matchCommonMatching = false,
            item = this.getItem(),
            parentItem = this.getParentItem();
        if (
            (saleObject instanceof this.getItemCategoryType() && item && item.isDescendantOf(saleObject, parentItem)) ||
            (saleObject instanceof this.getItemType() && item && (item === saleObject || (saleObject.isPackage && saleObject.subServices && saleObject.subServices.indexOf(item) !== -1) || (parentItem && parentItem === saleObject))) ||
            (saleObject === RootStatCategorie) ||
            (saleObject === HrRootCategory) ||
            (saleObject === NbCustormerCategoryStat) ||
            (saleObject === NbCustormerCategoryStat.subCategories.MEN_VISITS && this.getSale().customer && this.getSale().customer.gender === 'M') ||
            (saleObject === NbCustormerCategoryStat.subCategories.WOMEN_VISITS && this.getSale().customer && this.getSale().customer.gender === 'W') ||
            (saleObject === NbCustormerCategoryStat.subCategories.CHILDREN_VISITS && this.getSale().customer && this.getSale().customer.gender === 'C') ||
            (saleObject === NbCustormerCategoryStat.subCategories.UNDEFINED_VISITS && this.getSale().customer && this.getSale().customer.gender === null) ||
            (saleObject === NbCustormerCategoryStat.subCategories.PASSENGER_VISITS && !this.getSale().customer) ){
            matchCommonMatching = true;
        }
        return matchCommonMatching;
    };

    SaleItem.prototype.isSaleWithTree = function(){
        return true;
    };

    SaleItem.prototype.getQuantity = function(){
        return 1;
    };

    SaleItem.prototype.getStatQuantity = function(){
        return (this.getQuantity() * (this.getSale().status === 'credit' ? -1 : 1));
    };

    SaleItem.prototype.getDuration = function(){
        return 0;
    };

    SaleItem.prototype.getStatDuration = function(){
        return (this.getDuration() * (this.getSale().status === 'credit' ? -1 : 1));
    };

    SaleItem.prototype.matchAllSaleObjects = function(saleObjects, additionalFilters, firstDayOfPeriod, currentDay){
        let matchAllSaleObject = true;

        for (let k = 0; k < saleObjects.length; k++) {
            let saleObject = saleObjects[k],
                matchSaleObject = false;

            if (
                (this.isSaleWithTree() && this.matchSaleTreeMatching(saleObject)) ||
                this.matchSaleItemMatching(saleObject, firstDayOfPeriod, currentDay) ||
                this.matchSpecificMatchingOfItem(saleObject)
            ){
                matchSaleObject = true;
            }
            matchAllSaleObject = matchAllSaleObject && matchSaleObject;
        }

        let matchOneAdditionalFilter = false;

        for (let k = 0; k < additionalFilters.length; k++) {
            let additionalFilter = additionalFilters[k],
                matchAdditionalFilter = false;

            if (
                (additionalFilter === NbCustormerCategoryStat.subCategories.MEN_VISITS && this.getSale().customer && this.getSale().customer.gender === 'M') ||
                (additionalFilter === NbCustormerCategoryStat.subCategories.WOMEN_VISITS && this.getSale().customer && this.getSale().customer.gender === 'W') ||
                (additionalFilter === NbCustormerCategoryStat.subCategories.CHILDREN_VISITS && this.getSale().customer && this.getSale().customer.gender === 'C') ||
                (additionalFilter instanceof HumanResource && this.humanResource === additionalFilter)
            ) {

                matchAdditionalFilter = true;

            }
            matchOneAdditionalFilter = matchOneAdditionalFilter || matchAdditionalFilter;
        }

        return (matchAllSaleObject && (matchOneAdditionalFilter || additionalFilters.length === 0));
    };

    SaleItem.prototype.getSale = function()
    {
        return this.sale;
    };

    SaleItem.prototype.incrementSalesDatasForSubSales = function(salesData, firstDayOfPeriod, lastDayOfPeriod){
        salesData.subSales.push(this);
        salesData.qteSubSales += this.getStatQuantity();
        salesData.subSalesWithoutBooking.push(this);
        salesData.qteSubSalesWithoutBooking += this.getStatQuantity();
    };

    SaleItem.prototype.incrementSalesDatasForOldAndNewCustomer = function(salesData, firstDayOfPeriod){
        if (this.getSale().customer && (this.getSale().customer.hasSaleBefore(firstDayOfPeriod) || this.getSale().customer.hasBookingBefore(firstDayOfPeriod))) {
            if(salesData.subSalesOldCustomer.indexOf(this) === -1) {
                salesData.subSalesOldCustomer.push(this);
                salesData.qteSubSalesOldCustomer += this.getStatQuantity();
            }

            if(salesData.salesOldCustomer.indexOf(this.getSale()) === -1) {
                salesData.salesOldCustomer.push(this.getSale());
            }
        }
        else {
            if(salesData.subSalesNewCustomer.indexOf(this) === -1) {
                salesData.subSalesNewCustomer.push(this);
                salesData.qteSubSalesNewCustomer += this.getStatQuantity();
            }

            if(salesData.salesNewCustomer.indexOf(this.getSale()) === -1) {
                salesData.salesNewCustomer.push(this.getSale());
            }
        }
    };

    SaleItem.prototype.incrementSalesDatas = function(salesData, saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode, currentDay){
        if(this.matchAllSaleObjects(saleObjects, additionalFilters, firstDayOfPeriod, currentDay)) {

            for (let k = 0; k < saleObjects.length; k++) {
                let saleObject = saleObjects[k];

                if (saleObject instanceof HumanResource) {
                    salesData.humanResource = saleObject;
                    break;
                }
            }
            salesData.price += this.getDiscountPrice(taxMode);
            salesData.duration += this.getStatDuration();
            salesData.subSalesStep.push(this);

            this.incrementSalesDatasForSubSales(salesData, firstDayOfPeriod, lastDayOfPeriod);

            if (salesData.sales.indexOf(this.getSale()) === -1 && !this.getSale().isCancelledOrCredit()) {
                salesData.sales.push(this.getSale());
                salesData.qteSales += 1;
                if (this.getSale().status === "sold" && (this.getSale().saleProducts.length > 0 || this.getSale().saleServices.length > 0 || this.getSale().saleCures.length > 0 || this.getSale().loyaltyCardItems.length > 0)) {
                    salesData.qteSalesSold += 1;
                }

                if (!this.getSale().booking) {
                    salesData.salesWithoutBooking.push(this.getSale());
                }

                if (this.getSale().booking && this.getSale().booking.day && firstDayOfPeriod && lastDayOfPeriod && (this.getSale().booking.day.id < firstDayOfPeriod.id || this.getSale().booking.day.id > lastDayOfPeriod.id)) {
                    salesData.salesWithBookingOutOfPeriod.push(this.getSale());
                }
            }

            if (firstDayOfPeriod) {
                this.incrementSalesDatasForOldAndNewCustomer(salesData, firstDayOfPeriod);

                if (this.getSale().customer) {
                    let salesOfPeriod = this.getSale().customer.getLoyaltySalesOfPeriod(firstDayOfPeriod, currentDay, salesData.humanResource ? salesData.humanResource.id : null),
                        bookingsOfPeriod = this.getSale().customer.getLoyaltyBookingsOfPeriod(firstDayOfPeriod, currentDay, salesData.humanResource ? salesData.humanResource.id : null);

                    if (salesOfPeriod.length > 0 || bookingsOfPeriod.length > 0) {
                        if (salesData.loyaltyCustormers.indexOf(this.getSale().customer) === -1) {
                            salesData.loyaltyCustormers.push(this.getSale().customer);
                        }
                    }
                    else if (salesData.customersFirstVisit.indexOf(this.getSale().customer) === -1 && !this.getSale().isCancelledOrCredit()) {
                        salesData.customersFirstVisit.push(this.getSale().customer);
                    }
                }
            }

            if (this.getSale().customer) {
                if (salesData.customers.indexOf(this.getSale().customer) === -1 && !this.getSale().isCancelledOrCredit()) {
                    salesData.customers.push(this.getSale().customer);
                    salesData.nbCustomers += 1;
                }

                //check the condition (difference beetween service and other items?)
                if (!this.getSale().isCancelledOrCredit() && (!this.getSale().booking || (this.getSale().booking && this.getSale().booking.status !== 'notCame' && this.getSale().booking.day && this.getSale().day && firstDayOfPeriod && (this.getSale().booking.day.id >= this.getSale().day.id || this.getSale().booking.day.id < firstDayOfPeriod.id)))) {
                    if (salesData.customersSales.indexOf(this.getSale().customer) === -1) {
                        salesData.customersSales.push(this.getSale().customer);
                    }

                    if (salesData.customersFirstSales.indexOf(this.getSale().customer) === -1 && !this.getSale().customer.hasSaleBetween(firstDayOfPeriod, currentDay) && !this.getSale().customer.hasBookingBetween(firstDayOfPeriod, currentDay, this.getSale())) {
                        salesData.customersFirstSales.push(this.getSale().customer);
                    }
                    if (salesData.customersFirstSalesOfSaleObject.indexOf(this.getSale().customer) === -1 && !this.getSale().customer.hasSaleBetween(firstDayOfPeriod, currentDay, null, saleObjects, additionalFilters, currentDay) && !this.getSale().customer.hasBookingBetween(firstDayOfPeriod, currentDay, this.getSale(), saleObjects, additionalFilters)) {
                        salesData.customersFirstSalesOfSaleObject.push(this.getSale().customer);
                    }
                }
            }
            else if (salesData.matchedSalesOfPassageCustomer.indexOf(this.getSale()) === -1) {
                salesData.matchedSalesOfPassageCustomer.push(this.getSale());
            }
        }
    };

    return SaleItem;
}]);


// WEBPACK FOOTER //
// ./js/services/models/SaleItem.js